(function () {
  function throttle(fn) {
    let ticking = false;
    return function () {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          fn();
          ticking = false;
        });
        ticking = true;
      }
    };
  }

  function updateSection(section) {
    const rect = section.getBoundingClientRect();
    const viewportH = window.innerHeight || document.documentElement.clientHeight;
    // Compute progress as section enters and passes through the viewport
    const total = rect.height + viewportH;
    const progressed = Math.min(total, Math.max(0, viewportH - rect.top));
    const progress = total > 0 ? progressed / total : 0; // 0..1

    const items = Array.from(section.querySelectorAll('.right-text ul li'));
    if (!items.length) return;

    // Map progress to index ranges
    const idx = Math.max(0, Math.min(items.length - 1, Math.floor(progress * items.length)));
    items.forEach((li, i) => {
      if (i === idx) {
        li.setAttribute('data-active', 'true');
      } else {
        li.removeAttribute('data-active');
      }
    });
  }

  function init() {
    const sections = Array.from(document.querySelectorAll('.kinematic-brewer'));
    if (!sections.length) return;

    const onScroll = throttle(() => {
      sections.forEach(updateSection);
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();